function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask5",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 60,
  height: 60
}, React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 15,
  stroke: "black",
  strokeWidth: 30
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask5)"
}, React.createElement("g", {
  opacity: 0.636
}, React.createElement("path", {
  d: "M23.203 55.509C10.186 55.509 3 35.696 3 22.679C3 9.66 20.287 5 33.305 5C46.323 5 56.876 15.553 56.876 28.57C56.876 41.589 36.221 55.509 23.203 55.509Z",
  stroke: "#00C1F1"
}), React.createElement("path", {
  d: "M29.096 54.667C42.114 54.667 51.826 38.221 51.826 25.204C51.826 12.186 42.114 7.525 29.096 7.525C16.078 7.525 5.526 18.078 5.526 31.096C5.526 44.114 16.078 54.667 29.096 54.667Z",
  stroke: "#00C1F1"
})));

var Svg6 = function Svg6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/6.6fd55632.svg";
export { ForwardRef as ReactComponent };